import React from 'react';
import ReactDOM from 'react-dom/client'; //react-dom/clientからimportする
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')); //rootを作成する
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);